<template>
  <!-- 中台 -->
  <div class="statistics">
    <!-- 数据累计 -->
    <div class="cumulative-ul">
      <div class="cumulative-li">
        <div class="cumulative-li-left">
          <span>{{ $t("pages.statistics.text1") }}</span>
          <span>
            <countTo
              :startVal="0"
              :endVal="statistics.bikeTotal ? statistics.bikeTotal : 0"
              :duration="3000"
            ></countTo>
          </span>
        </div>
        <div class="cumulative-li-right">
          <img src="../../assets/images/statistics-icon1.png" alt="" />
        </div>
      </div>
      <div class="cumulative-li">
        <div class="cumulative-li-left">
          <span>{{ $t("pages.statistics.text2") }}</span
          ><span>
            <countTo
              :startVal="0"
              :endVal="statistics.userTotal ? statistics.userTotal : 0"
              :duration="3000"
            ></countTo
          ></span>
        </div>
        <div class="cumulative-li-right">
          <img src="../../assets/images/statistics-icon2.png" alt="" />
        </div>
      </div>
      <div class="cumulative-li">
        <div class="cumulative-li-left">
          <span>{{ $t("pages.statistics.text3") }}</span
          ><span>
            <countTo
              :startVal="0"
              :endVal="
                statistics.ridingDistance ? statistics.ridingDistance : 0
              "
              :duration="3000"
            ></countTo>
          </span>
        </div>
        <div class="cumulative-li-right">
          <img src="../../assets/images/statistics-icon3.png" alt="" />
        </div>
      </div>
      <div class="cumulative-li">
        <div class="cumulative-li-left">
          <span>{{ $t("pages.statistics.text4") }}</span
          ><span>
            <countTo
              :startVal="0"
              :endVal="
                statistics.ridingActivity ? statistics.ridingActivity : 0
              "
              :duration="3000"
            ></countTo>
            %</span
          >
        </div>
        <div class="cumulative-li-right">
          <img src="../../assets/images/statistics-icon4.png" alt="" />
        </div>
      </div>
      <div class="cumulative-li">
        <div class="cumulative-li-left">
          <span>{{ $t("pages.statistics.text5") }}</span
          ><span>
            <countTo
              :startVal="0"
              :endVal="
                statistics.carbonEmission ? statistics.carbonEmission : 0
              "
              :duration="3000"
            ></countTo>
          </span>
        </div>
        <div class="cumulative-li-right">
          <img src="../../assets/images/statistics-icon5.png" alt="" />
        </div>
      </div>
    </div>

    <!-- 客户地域分布以及客户车辆分布 -->
    <div class="distribution-add">
      <div class="distribution module">
        <div class="module-header">
          <div class="title">{{ $t("pages.statistics.text6") }}</div>
        </div>
        <div class="distribution-content">
          <div id="distribution-map"></div>
          <div class="right-info">
            <div>
              <span>{{ $t("pages.statistics.text7") }}</span>
              <span>
                <countTo
                  :startVal="0"
                  :endVal="platformTotalNum ? platformTotalNum : 0"
                  :duration="3000"
                ></countTo>
              </span>
            </div>
            <div>
              <span>{{ $t("pages.statistics.text8") }}</span>
              <span>
                <countTo
                  :startVal="0"
                  :endVal="platformPublicNum ? platformPublicNum : 0"
                  :duration="3000"
                ></countTo>
              </span>
            </div>
            <div>
              <span>{{ $t("pages.statistics.text9") }}</span>
              <span>
                <countTo
                  :startVal="0"
                  :endVal="platformPrivateNum ? platformPrivateNum : 0"
                  :duration="3000"
                ></countTo
              ></span>
            </div>
          </div>
        </div>
      </div>
      <div class="add module">
        <div class="module-header">
          <div class="title">{{ $t("pages.statistics.text10") }}</div>
        </div>
        <div class="add-content">
          <div id="add-vehicle-echarts"></div>
        </div>
      </div>
    </div>

    <!-- 累计用户和新增用户 -->
    <div class="cumulative-add-user">
      <div class="cumulative-user">
        <div class="cumulative-add-user-title">
          {{ $t("pages.statistics.text11") }}
        </div>
        <div class="cumulative-add-user-content">
          <div id="cumulative-user"></div>
        </div>
      </div>
      <div class="add-user">
        <div class="module-header">
          <div class="title">{{ $t("pages.statistics.text12") }}</div>
          <div class="header-region">
            <span class="el-dropdown-link" v-if="searchUser == 1">
              {{ $t("pages.statistics.text13") }}
            </span>
            <span class="el-dropdown-link" v-if="searchUser == 7">
              {{ $t("pages.statistics.text14") }}
            </span>
            <span class="el-dropdown-link" v-if="searchUser == 30">
              {{ $t("pages.statistics.text15") }}
            </span>
            <el-dropdown @command="searchUserMethod">
              <span class="el-dropdown-link">
                <!--  {{ $t("afterSales.text34")
                }} --><i class="el-icon-arrow-down el-icon--right"></i>
              </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item command="1">
                  {{ $t("pages.statistics.text13") }}</el-dropdown-item
                >
                <el-dropdown-item command="7">
                  {{ $t("pages.statistics.text14") }}</el-dropdown-item
                >
                <el-dropdown-item command="30">{{
                  $t("pages.statistics.text15")
                }}</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
        </div>
        <div class="cumulative-add-user-content">
          <div id="add-user"></div>
        </div>
      </div>
    </div>

    <!-- 骑行里程趋势 -->
    <div class="riding-mileage module">
      <div class="module-header">
        <div class="title">{{ $t("pages.statistics.text16") }}</div>
        <div class="header-region">
          <span class="el-dropdown-link" v-if="searchRiding == 7">
            {{ $t("pages.statistics.text17") }}
          </span>
          <span class="el-dropdown-link" v-if="searchRiding == 14">
            {{ $t("pages.statistics.text18") }}
          </span>
          <span class="el-dropdown-link" v-if="searchRiding == 30">
            {{ $t("pages.statistics.text15") }}
          </span>
          <el-dropdown @command="searchRidingMethod">
            <span class="el-dropdown-link">
              <!--  {{ $t("afterSales.text34")
                }} --><i class="el-icon-arrow-down el-icon--right"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="7">
                {{ $t("pages.statistics.text17") }}</el-dropdown-item
              >
              <el-dropdown-item command="14">
                {{ $t("pages.statistics.text18") }}</el-dropdown-item
              >
              <el-dropdown-item command="30">{{
                $t("pages.statistics.text15")
              }}</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </div>
      <div class="add-content">
        <div id="ridin-echarts"></div>
      </div>
    </div>
    <!-- 骑行活跃趋势 -->
    <div class="riding-mileage module">
      <div class="module-header">
        <div class="title">{{ $t("pages.statistics.text19") }}</div>
        <div class="header-region">
          <span class="el-dropdown-link" v-if="searchCycling == 7">
            {{ $t("pages.statistics.text17") }}
          </span>
          <span class="el-dropdown-link" v-if="searchCycling == 14">
            {{ $t("pages.statistics.text18") }}
          </span>
          <span class="el-dropdown-link" v-if="searchCycling == 30">
            {{ $t("pages.statistics.text15") }}
          </span>
          <el-dropdown @command="searchCyclingMethod">
            <span class="el-dropdown-link">
              <!--  {{ $t("afterSales.text34")
                }} --><i class="el-icon-arrow-down el-icon--right"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="7">
                {{ $t("pages.statistics.text17") }}</el-dropdown-item
              >
              <el-dropdown-item command="14">
                {{ $t("pages.statistics.text18") }}</el-dropdown-item
              >
              <el-dropdown-item command="30">{{
                $t("pages.statistics.text15")
              }}</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </div>
      <div class="add-content">
        <div id="active-echarts"></div>
      </div>
    </div>
  </div>
</template>


<script>
import remoteLoad from "@/assets/js/remoteLoad.js";
import DiluEcharts from "../../components/pubilc/dilu-echarts.vue";
import * as echarts from "echarts";
import countTo from "vue-count-to";
import { mapState } from "vuex";
import HeatmapOverlay from "@/utils/gmaps-heatmap";
export default {
  data() {
    return {
      searchUser: "30", //新增用户搜索条件
      searchRiding: "30", //骑行里程条件
      searchCycling: "30", //骑行活跃条件
      map: null,
      center: [116.402921, 39.908177],
      statistics: {}, //统计数据
      mapList: [], //地图数据
      platformBikeDataList: [], //客户车辆分布
      platformTotalNum: 0,
      platformPrivateNum: 0,
      platformPublicNum: 0,
    };
  },
  mounted() {
    this.getDataStatistics();
    this.platformLocationData();
    this.platformBikeData();
    this.getUserTotal();
    this.getCreateUserTotal();
    this.getRidingMileage();
    this.getRidingActiveCycling();
  },
  components: {
    DiluEcharts,
    countTo,
  },
  computed: {
    ...mapState(["regionList", "currentRegion"]),
  },
  methods: {
    //骑行活跃
    searchCyclingMethod(e) {
      this.searchCycling = e;
      this.getRidingActiveCycling();
    },
    //骑行里程
    searchRidingMethod(e) {
      this.searchRiding = e;
      this.getRidingMileage();
    },
    //用户搜索条件
    searchUserMethod(e) {
      this.searchUser = e;
      this.getCreateUserTotal();
    },
    //统计数据
    getDataStatistics() {
      this.request.getDataStatistics().then((res) => {
        this.statistics = res.data;
      });
    },

    //客户地域分布接口
    platformLocationData() {
      this.request.platformLocationData().then((res) => {
        let arr = res.data.cityInfoVOList;
        let arr1 = [];
        for (let i in arr) {
          if (arr[i].cityLocation) {
            arr1.push([
              arr[i].cityLocation.split(",")[1],
              arr[i].cityLocation.split(",")[0],
            ]);
          }
        }
        this.mapList = arr1;
        this.platformTotalNum = res.data.platformTotalNum;
        this.platformPrivateNum = res.data.platformPrivateNum;
        this.platformPublicNum = res.data.platformPublicNum;

        let regionList = this.regionList;

        if (regionList[this.currentRegion].id != "cn") {
          if (window.google) {
            this.initMap();
            // 未载入谷歌地图API，则先载入API再初始化
          } else {
            // 载入谷歌地图和UI组件
            Promise.all([
              remoteLoad(
                "https://maps.googleapis.com/maps/api/js?key=AIzaSyByfqxMers4lp-sXvkU4P8dX4i6yQ3RZ84&libraries=visualization,places,geometry&language=en-us&region=EG"
              ),
            ]).then(() => {
              this.initMap();
            });
          }
        } else {
          if (window.AMap && window.AMapUI) {
            this.initMap();
            // 未载入高德地图API，则先载入API再初始化
          } else {
            // 载入高德地图和UI组件
            Promise.all([
              remoteLoad(
                "https://webapi.amap.com/maps?v=1.4.15&key=77faf27c291ef4d7a20bfb8d5f74b0b4&plugin=AMap.Riding"
              ),
            ]).then(() => {
              this.initMap();
            });
          }
        }

        // this.initMap();
        // console.log(arr1);
      });
    },

    //查询客户车辆数据
    platformBikeData() {
      this.request.platformBikeData().then((res) => {
        let arr = [];
        for (let i in res.data) {
          arr.push({
            value: res.data[i].bikeNum,
            name: res.data[i].platformName,
          });
        }
        this.platformBikeDataList = arr;
        this.initVehicleUserEcharts();
      });
    },

    //查询累计用户
    getUserTotal() {
      this.request.getUserTotal().then((res) => {
        let x = [];
        let y = [];
        for (let i in res.data) {
          x.push(res.data[i].appUserNum);
          y.push(res.data[i].platformShortName);
        }
        this.initCumulativeUser(x, y);
      });
    },

    // 查询平台方的新增用户注册图表信息
    getCreateUserTotal() {
      let str = "?dayTime=" + this.searchUser;
      this.request.getCreateUserTotal(str).then((res) => {
        let x = [];
        let y = [];
        for (let i in res.data) {
          x.push(res.data[i].appUserNum);
          y.push(res.data[i].platformShortName);
        }
        this.initAddUser(x, y);
      });
    },

    //骑行里程统计图
    getRidingMileage() {
      let str = "?dayTime=" + this.searchRiding;
      this.request.getRidingMileage(str).then((res) => {
        let x = [];
        let y = [];
        for (let i in res.data) {
          x.push(res.data[i].oneDay);
          y.push(res.data[i].ridingMileage);
        }
        this.initRidinEcharts(x, y);
      });
    },

    //骑行活跃统计
    getRidingActiveCycling() {
      let str = "?dayTime=" + this.searchCycling;
      this.request.getRidingActiveCycling(str).then((res) => {
        let x = [];
        let y = [];
        for (let i in res.data) {
          x.push(res.data[i].oneDay);
          y.push(res.data[i].ridingActivity);
        }
        this.initActiveEcharts(x, y);
      });
    },

    //初始化地图
    initMap() {
      let arr = this.regionList;
      if (arr[this.currentRegion].id != "cn") {
        this.initGoogleMap();
      } else {
        this.initAmap();
      }
    },

    //google地图
    initGoogleMap() {
      let that = this;
      let heatmapData = [];
      let center = null;
      // 按坐标分组统计每个位置的点数量，作为权重
      let coordCount = {};
      for (let i in that.mapList) {
        let lat = Number(that.mapList[i][1]);
        let lng = Number(that.mapList[i][0]);
        let key = lat.toFixed(5) + "," + lng.toFixed(5);
        if (!coordCount[key]) {
          coordCount[key] = { lat: lat, lng: lng, count: 0 };
        }
        coordCount[key].count++;
        if (!center) {
          center = { lat: lat, lng: lng };
        }
      }
      // 用幂函数压缩 value，让密度差异更自然（低值更冷、高值才热）
      let maxValue = 0;
      for (let key in coordCount) {
        let item = coordCount[key];
        let v = Math.pow(item.count, 0.55); // count=1→1, count=10→3.5, count=50→8.6, count=100→12.6
        heatmapData.push({ lat: item.lat, lng: item.lng, value: v });
        if (v > maxValue) maxValue = v;
      }

      const map = new google.maps.Map(
        document.getElementById("distribution-map"),
        {
          mapId: "1dac188ecae44d48",
          zoom: 4,
          center: center || {
            lat: 51.288470285086476,
            lng: -0.09321210101420174,
          },
          disableDefaultUI: true,
        }
      );

      let heatmapOverlay = new HeatmapOverlay(map, {
        radius: 22,
        maxOpacity: 0.65,
        scaleRadius: false,
        useLocalExtrema: false,
        latField: "lat",
        lngField: "lng",
        valueField: "value",
        gradient: {
          0.00: "rgba(0, 0, 255, 0)",
          0.15: "rgba(31, 91, 204, 0.4)",
          0.30: "rgba(31, 91, 204, 1)",
          0.50: "rgba(0, 255, 255, 1)",
          0.65: "rgba(0, 200, 0, 1)",
          0.80: "rgba(255, 255, 0, 1)",
          0.92: "rgba(255, 140, 0, 1)",
          1.00: "rgba(255, 0, 0, 1)",
        },
      });

      heatmapOverlay.setData({
        max: maxValue || 1,
        min: 0,
        data: heatmapData,
      });
      this.heatmapOverlay = heatmapOverlay;
    },

    //高德地图
    initAmap() {
      let that = this;
      let positions = that.mapList;
      let center = [];
      // console.log([Number(positions[0][0]), Number(positions[0][1])]);
      if (positions.length < 1) {
        center = [116.394681, 39.900802];
      } else {
        center = [Number(positions[0][0]), Number(positions[0][1])];
      }
      var map = new AMap.Map("distribution-map", {
        zoom: 4,
        showLabel: false,
        expandZoomRange: true,
        center: center,
        pitch: 60,
        mapStyle: "amap://styles/398469a1eaea0a930c1cb33226ee3080", //设置地图的显示样式
      });

      map.on("complete", function () {
        let arr = [];
        for (var i = 0; i < positions.length; i++) {
          var curPosition = positions[i];
          arr[i] = new AMap.CircleMarker({
            center: curPosition,
            radius: 10 + Math.random() * 3, //3D视图下，CircleMarker半径不要超过64px
            strokeColor: "transparent",
            strokeWeight: 1,
            fillColor: "#1F5BCC",
            fillOpacity: 0.5,
            zIndex: 10,
            bubble: true,
            cursor: "pointer",
            clickable: true,
          });
          arr[i].setMap(map);
        }
        // map.setFitView(arr);
      });
    },

    //客户车辆分布
    initVehicleUserEcharts() {
      let that = this;
      var chartDom = document.getElementById("add-vehicle-echarts");
      var myChart = echarts.init(chartDom);
      var option;

      option = {
        tooltip: {
          trigger: "item",
        },
        legend: {
          orient: "vertical",
          right: 50,
          bottom: 50,
        },
        series: [
          {
            type: "pie",
            radius: ["30%", "60%"],
            avoidLabelOverlap: false,
            width: "80%",
            height: "80%",
            left: "center",
            bottom: "center",
            label: {
              show: false,
              position: "center",
            },
            emphasis: {
              label: {
                show: true,
                fontSize: "16",
                fontWeight: "bold",
              },
            },
            itemStyle: {
              normal: {
                color: function (params) {
                  //自定义颜色
                  var colorList = [
                    "#1F5BCC",
                    "#FF6969",
                    "#F2B455",
                    "#46E1EC",
                    "#D7DDEB",
                  ];
                  return colorList[params.dataIndex];
                },
              },
            },
            labelLine: {
              show: false,
            },
            data: that.platformBikeDataList,
          },
        ],
      };

      option && myChart.setOption(option);
    },

    //累计用户
    initCumulativeUser(x, y) {
      var chartDom = document.getElementById("cumulative-user");
      var myChart = echarts.init(chartDom);
      var option;
      option = {
        grid: {
          left: 100,
        },
        xAxis: {
          type: "value",
        },
        yAxis: {
          type: "category",
          inverse: true,
          data: y,
        },
        series: {
          type: "bar",
          data: x,
          showBackground: true,
          itemStyle: {
            color: new echarts.graphic.LinearGradient(0, 0, 1, 0, [
              { offset: 0, color: "#fc9982" },
              { offset: 1, color: "#f3b56d" },
            ]),
          },
          emphasis: {
            itemStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 1, 0, [
                { offset: 0, color: "#f3b56d" },
                { offset: 1, color: "#fc9982" },
              ]),
            },
          },
        },
      };

      option && myChart.setOption(option);
    },

    //新增用户
    initAddUser(x, y) {
      var chartDom = document.getElementById("add-user");
      var myChart = echarts.init(chartDom);
      var option;

      option = {
        xAxis: {
          type: "category",
          data: y,
        },
        yAxis: {
          type: "value",
          max: "dataMax",
          splitNumber: 5,
          minInterval: 1,
        },
        series: [
          {
            data: x,
            type: "bar",
            showBackground: true,
            itemStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: "rgba(75, 163, 214, 1)" },
                { offset: 1, color: "rgba(74, 246, 246, 1)" },
              ]),
            },
            emphasis: {
              itemStyle: {
                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  { offset: 0, color: "rgba(74, 246, 246, 1)" },
                  { offset: 1, color: "rgba(75, 163, 214, 1)" },
                ]),
              },
            },
          },
        ],
      };

      option && myChart.setOption(option);
    },
    //骑行里程趋势
    initRidinEcharts(x, y) {
      var chartDom = document.getElementById("ridin-echarts");
      var myChart = echarts.init(chartDom);
      var option;
      let date = x;
      let data = y;
      option = {
        tooltip: {
          trigger: "axis",
          position: function (pt) {
            return [pt[0], "10%"];
          },
        },
        xAxis: {
          type: "category",
          boundaryGap: false,
          data: date,
        },
        yAxis: {
          type: "value",
          boundaryGap: [0, "100%"],
          max: "dataMax",
          splitNumber: 5,
          minInterval: 1,
        },
        series: [
          {
            type: "line",
            smooth: 0.6,
            symbol: "none",
            sampling: "lttb",
            itemStyle: {
              color: "rgba(31, 91, 204, 1)",
            },
            areaStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                {
                  offset: 0,
                  color: "#1F5BCC",
                },
                {
                  offset: 1,
                  color: "rgba(45, 110, 232, 0)",
                },
              ]),
            },
            data: data,
          },
        ],
      };

      option && myChart.setOption(option);
    },
    //骑行活跃趋势
    initActiveEcharts(x, y) {
      var chartDom = document.getElementById("active-echarts");
      var myChart = echarts.init(chartDom);
      var option;
      let date = x;
      let data = y;
      option = {
        tooltip: {
          trigger: "axis",
          position: function (pt) {
            return [pt[0], "10%"];
          },
        },
        xAxis: {
          type: "category",
          boundaryGap: false,
          data: date,
        },
        yAxis: {
          type: "value",
          boundaryGap: [0, "100%"],
          max: "dataMax",
          splitNumber: 5,
          minInterval: 1,
        },
        series: [
          {
            type: "line",
            smooth: 0.6,
            symbol: "none",
            sampling: "lttb",
            itemStyle: {
              color: "rgba(239, 162, 43, 1)",
            },
            areaStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                {
                  offset: 0,
                  color: "#EFA22B",
                },
                {
                  offset: 1,
                  color: "rgba(229, 148, 25, 0)",
                },
              ]),
            },
            data: data,
          },
        ],
      };

      option && myChart.setOption(option);
    },
  },
};
</script>


<style scoped>
.statistics {
  padding: 25px 25px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
}
.cumulative-ul {
  display: flex;
  justify-content: space-between;
  margin-bottom: 25px;
}
.cumulative-li {
  width: calc(20% - 25px);
  height: 120px;
  background-color: #fff;
  padding: 26px;
  box-sizing: border-box;
  display: flex;
  justify-content: space-between;
  align-items: center;
  box-shadow: 0px 3px 6px #f0f3fa;
  border-radius: 6px;
}
.cumulative-li-left {
  display: flex;
  flex-direction: column;
}
.cumulative-li-left span:first-child {
  font-size: 14px;
  font-weight: normal;
  color: #7685a9;
  margin-bottom: 8px;
}
.cumulative-li-left span:last-child {
  font-size: 28px;
  font-family: DIN;
  font-weight: bold;
  color: #000000;
}
.cumulative-li-right {
  width: 40px;
  flex-shrink: 0;
}
.cumulative-li-right img {
  width: 100%;
}
.distribution-add {
  display: flex;
  justify-content: space-between;
  margin-bottom: 25px;
}
.distribution {
  width: calc(2 / 3 * 100% - 25px);
  height: 558px;
  background: #ffffff;
  box-shadow: 0px 3px 6px #f0f3fa;
  opacity: 1;
  border-radius: 6px;
  margin-right: 25px;
}
.add {
  flex: 1;
  background: #ffffff;
  box-shadow: 0px 3px 6px #f0f3fa;
  opacity: 1;
  border-radius: 6px;
}
.module {
  padding: 18px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
}
.module-header {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
  padding: 0 10px;
  justify-content: space-between;
}
.module-header .title {
  font-size: 18px;
  font-weight: 600;
  color: #000000;
}
.distribution-content {
  flex: 1;
  padding: 0 10px;
  box-sizing: border-box;
  position: relative;
}
.right-info {
  position: absolute;
  height: 100%;
  width: 190px;
  background-color: rgba(255, 255, 255, 0.6);
  z-index: 99;
  top: 0;
  right: 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-content: center;
}
.right-info div {
  margin-bottom: 40px;
  display: flex;
  flex-direction: column;
  padding-left: 45px;
  box-sizing: border-box;
  padding-right: 20px;
}
.right-info div span:first-child {
  font-size: 14px;
  font-family: 萍方-简;
  font-weight: normal;
  color: #7685a9;
  margin-bottom: 20px;

  /* width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap; */
}
.right-info div span:last-child {
  font-size: 30px;
  font-family: DIN;
  font-weight: bold;
  line-height: 28px;
  color: #000000;
}
#distribution-map {
  width: 100%;
  height: 100%;
}
.header-region {
  background: rgba(210, 222, 244, 0.35);
  border-radius: 15px;
  padding: 5px 20px;
  box-sizing: border-box;
}
.add-content {
  flex: 1;
}
.riding-mileage {
  height: 400px;
  background: #ffffff;
  box-shadow: 0px 3px 6px #f0f3fa;
  border-radius: 6px;
  margin-bottom: 25px;
  flex-shrink: 0;
}
#ridin-echarts {
  width: 100%;
  height: 100%;
}
#add-vehicle-echarts {
  width: 100%;
  height: 100%;
}
#active-echarts {
  width: 100%;
  height: 100%;
}
.cumulative-add-user {
  display: flex;
  height: 536px;
  background: #ffffff;
  box-shadow: 0px 3px 6px #f0f3fa;
  border-radius: 6px;
  margin-bottom: 25px;
  flex-shrink: 0;
  padding: 18px;
  box-sizing: border-box;
}
.cumulative-user {
  width: calc(3 / 5 * 100% - 40px);
  margin-right: 40px;
  display: flex;
  flex-direction: column;
}
.add-user {
  flex: 1;
  display: flex;
  flex-direction: column;
}
.cumulative-add-user-title {
  margin-bottom: 10px;
  font-size: 20px;
  font-weight: 600;
  color: #000000;
}
.cumulative-add-user-content {
  flex: 1;
}
#cumulative-user {
  width: 100%;
  height: 100%;
}
#add-user {
  width: 100%;
  height: 100%;
}
</style>